import { render } from "./PracticeTestStudent.vue?vue&type=template&id=e2e51906&scoped=true"
import script from "./PracticeTestStudent.vue?vue&type=script&lang=js"
export * from "./PracticeTestStudent.vue?vue&type=script&lang=js"

import "./PracticeTestStudent.vue?vue&type=style&index=0&id=e2e51906&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Private\\Edukatta_Private_Managment_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2e51906"]])

export default __exports__